module.exports = __webpack_public_path__ + "media/images/countryrect/mg-95c5c281e60fa74d3d40e6e319637bd5.svg";